import { z } from 'zod';

import type {
  HoldingUnitEventEnvelopeBase,
  HoldingUnitEventOrigin,
} from './holding-unit-event-envelope.dto.js';
import {
  holdingUnitEventEntityTypeValues,
  holdingUnitEventOriginKindValues,
} from './holding-unit-event-envelope.dto.js';

export const HoldingUnitEventEntityTypeSchema = z.enum(holdingUnitEventEntityTypeValues);
export const HoldingUnitEventOriginKindSchema = z.enum(holdingUnitEventOriginKindValues);

export const HoldingUnitEventOriginSchema = z
  .object({
    kind: HoldingUnitEventOriginKindSchema,
    deviceId: z.uuid().nullable(),
    deviceClaimId: z.uuid().nullable(),
  })
  .strict() satisfies z.ZodType<HoldingUnitEventOrigin>;

export const HoldingUnitEventEnvelopeBaseSchema = z
  .object({
    entityType: HoldingUnitEventEntityTypeSchema,
    entityId: z.uuid(),
    eventType: z.string().trim().min(1).max(120),
    eventSchemaVersion: z.literal(1),
    streamVersion: z.number().int().positive(),
    eventId: z.uuid(),
    commandId: z.uuid(),
    commandType: z.string().trim().min(1).max(120),
    correlationId: z.uuid().nullable().optional(),
    causationId: z.uuid().nullable().optional(),
    companyId: z.uuid(),
    storeId: z.uuid(),
    locationId: z.uuid(),
    stationId: z.uuid(),
    actorUserId: z.uuid(),
    occurredAt: z.iso.datetime(),
    origin: HoldingUnitEventOriginSchema,
    payload: z.unknown(),
  })
  .strict() satisfies z.ZodType<HoldingUnitEventEnvelopeBase>;
